export default initData => {
    const { itemId, viewItemPageResponse } = initData;
    const { item, campaign } = viewItemPageResponse;

    return {
        campaign: { ...campaign },
        descriptions: {},
        descriptionLoading: false,
        descriptionLoadingError: false,
        itemTitle: item.title,
        itemId: itemId,
        showTranslatedDescription: false
    };
};
